import React from 'react';

import EnhancedTab from '../../../../../../../../../../../lib/designSystem/TabSimulation';
import VerificationModule from '../../../../../../../../Collection/components/Verification';
import FactoringApprovalModule from './components/ApprovalModule';

const FactoringOperationsTab = (props: any) => {
  const {
    setOpenShoppingCart,
    selectedRequest,
    setSuccessOpen,
    setFailureOpen,
    setUp,
    selectedId,
  } = props;
  const startValue = 0;

  const tabs = [
    {
      index: 1,
      label: 'Comité',
      component: (
        <div>
          <FactoringApprovalModule
            selectedRequest={selectedRequest}
            requestType="factoring-request"
            setOpenShoppingCart={setOpenShoppingCart}
            setSuccessOpen={setSuccessOpen}
            setFailureOpen={setFailureOpen}
            setUp={setUp}
            selectedId={selectedId}
          />
        </div>
      ),
    },
    {
      index: 2,
      label: 'Verificación',
      component: (
        <VerificationModule
          preSettedFactoringRequestId={selectedRequest?.id}
          preSettedConfirmationType="all"
          setOpenShoppingCart={setOpenShoppingCart}
          showCreditLine
        />
      ),
      path: 'recieved',
    },
  ];

  return <EnhancedTab startValue={startValue} tabs={tabs} />;
};

export default FactoringOperationsTab;
